module.exports = __webpack_public_path__ + "static/img/cursor.c563f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cursor.png
// module id = pHLT
// module chunks = 1